export default __webpack_public_path__ + "images/cert-e30.png?e5884479cef9f2038d5e37d804f10d5e";